export const FETCH_TRANSFER_STATUS_LIST_PENDING = "FETCH_TRANSFER_STATUS_LIST_PENDING";
export const FETCH_TRANSFER_STATUS_LIST_REJECTED = "FETCH_TRANSFER_STATUS_LIST_REJECTED";
export const FETCH_TRANSFER_STATUS_LIST_FULFILLED = "FETCH_TRANSFER_STATUS_LIST_FULFILLED";



// WEBPACK FOOTER //
// ./src/constants/transferStatuses.js